import Vue from 'vue'
import HomeApp from './ThemeAqy'

/* eslint-disable no-new */
new Vue({
    el: '#home-app',
    template: '<HomeApp/>',
    components: { HomeApp }
})


// WEBPACK FOOTER //
// ./src/h5/themeaqy/index_aqy.js